export const initUsersSettings = resp => {
  return {
    type: "INIT_USERS_SETTINGS"
  };
};

export const selectRole = role => {
  return {
    type: "SELECT_ROLE",
    role
  };
};

export const setRole = role => {
  return {
    type: "SET_ROLE",
    role
  };
};

export const setSelectedUsers = selectedUsers => {
  return {
    type: "SET_SELECTED_USERS",
    selectedUsers
  };
};

export const selectSearchWord = searchWord => {
  return {
    type: "SELECT_SEARCH_WORD",
    searchWord
  };
};

export const setDefaultAuthParameters = params => {
  return {
    type: "SET_DEFAULT_AUTH_PARAMS",
    params
  };
};

export const setAllowConfigurateBudget = allowConfigurateBudget => {
  return {
    type: "SET_ALLOW_CONFIGURATE_BUDGET",
    allowConfigurateBudget
  };
};
export const setAllowUpdatingBillingView = allowUpdatingBillingView => {
  return {
    type: "SET_UPDATE_BILLING_VIEW",
    allowUpdatingBillingView
  };
};
export const setAllowUpdatingTarifClients = allowUpdatingTarifClients => {
  return {
    type: "SET_UPDATE_TARIF_CLIENT",
    allowUpdatingTarifClients
  };
};
export const setAllowUpdatingNewClients = allowUpdatingNewClients => {
  return {
    type: "SET_UPDATE_NEW_CLIENT",
    allowUpdatingNewClients
  };
};
export const setAllowUpdatingDepartClients = allowUpdatingDepartClients => {
  return {
    type: "SET_UPDATE_DEPART_CLIENT",
    allowUpdatingDepartClients
  };
};
export const setAllowAccessToClientCollaboratorRelation = allowAccessToClientCollaboratorRelation => {
  return {
    type: "SET_ALLOW_ACCESS_TO_CLIENT_COLLABORATOR_RELATION",
    allowAccessToClientCollaboratorRelation
  };
};
export const setAllowAccessToClientInformations = allowAccessToClientInformations => {
  return {
    type: "SET_ALLOW_ACCESS_TO_CLIENT_INFORMATION",
    allowAccessToClientInformations
  };
};
export const setAllowAccessToGlobalBudget = allowAccessToGlobalBudget => {
  return {
    type: "SET_ALLOW_ACCESS_TO_GLOBAL_BUDGET",
    allowAccessToGlobalBudget
  };
};
export const setAllowUpdatingOffrePrice = allowUpdatingOffrePrice => {
  return {
    type: "SET_ALLOW_UPDATEING_OFFER_PRICE",
    allowUpdatingOffrePrice
  };
};
export const setAllowToAddDeleger = allowToAddDeleger => {
  return {
    type: "SET_ALLOW_TO_ADD_DLEGER",
    allowToAddDeleger
  };
};
export const setAllowUpdateBudgetedBenchmark = allowUpdateBudgetedBenchmark => {
  return {
    type: "SET_ALLOW_UPDATE_BUDGET_BENCHMARK",
    allowUpdateBudgetedBenchmark
  };
};
export const setAllowAccessToStatisticsCards = allowAccessToStatisticsCards => {
  return {
    type: "SET_ALLOW_ACCESS_TO_STATISTICS_CARDS",
    allowAccessToStatisticsCards
  };
};

export const setAllowAccessToCorrectionCards = allowAccessToCorrectionCards => {
  return {
    type: "SET_ALLOW_ACCESS_TO_CORRECTION_CARDS",
    allowAccessToCorrectionCards
  };
};
export const setAllowVisualizationOfBudgetedTime = allowVisualizationOfBudgetedTime => {
  return {
    type: "SET_ALLOW_VISUALIZATION_OF_BUDGETED_TIME",
    allowVisualizationOfBudgetedTime
  };
};
export const setAllowVisualizationOfBudgetedBenchmark = allowVisualizationOfBudgetedBenchmark => {
  return {
    type: "SET_ALLOW_VISUALIZATION_OF_BUDGETED_BENCHMARK",
    allowVisualizationOfBudgetedBenchmark
  };
};
export const setAllowVisualizationOfRealizedTime = allowVisualizationOfRealizedTime => {
  return {
    type: "SET_ALLOW_VISUALIZATION_OF_REALIZED_TIME",
    allowVisualizationOfRealizedTime
  };
};
export const setAllowVisualizationOfRealizedBenchmark = allowVisualizationOfRealizedBenchmark => {
  return {
    type: "SET_ALLOW_VISUALIZATION_OF_REALIZED_BENCHMARK",
    allowVisualizationOfRealizedBenchmark
  };
};

export const setAllowAdjustDistributionOfTasksByRole = allowAdjustDistributionOfTasksByRole => {
  return {
    type: "SET_ALLOW_ADJUST_DISTRIBUTION_OF_TASKS_BY_ROLE",
    allowAdjustDistributionOfTasksByRole
  };
};
export const setAllowAttributionBU = allowAttributionBU => {
  return {
    type: "SET_ALLOW_ATTRIBUTION_BU",
    allowAttributionBU
  };
};
export const setAllowAttributionSquad = allowAttributionSquad => {
  return {
    type: "SET_ALLOW_ATTRIBUTION_SQUAD",
    allowAttributionSquad
  };
};
export const setAllowCollabToDevCard = allowCollabToDevCard => {
  return {
    type: "SET_ALLOW_COLLAB_TO_DEV_CARD",
    allowCollabToDevCard
  };
};
export const setAllowAttributionCluster = allowAttributionCluster => {
  return {
    type: "SET_ALLOW_ATTRIBUTION_CLUSTER",
    allowAttributionCluster
  };
};
export const setAllowSelectAppliedModel = allowSelectAppliedModel => {
  return {
    type: "SET_ALLOW_SELECT_APPLIED_MODEL",
    allowSelectAppliedModel
  };
};
export const setAllowTodragAndDropFromTODO = allowTodragAndDropFromTODO => {
  return {
    type: "SET_ALLOW_TO_DRAG_AND_DROP_FROM_TODO",
    allowTodragAndDropFromTODO
  };
};
export const setAllowTodragAndDropFromWIP = allowTodragAndDropFromWIP => {
  return {
    type: "SET_ALLOW_TO_DRAG_AND_DROP_FROM_WIP",
    allowTodragAndDropFromWIP
  };
};
export const setAllowTodragAndDropFromDONE = allowTodragAndDropFromDONE => {
  return {
    type: "SET_ALLOW_TO_DRAG_AND_DROP_FROM_DONE",
    allowTodragAndDropFromDONE
  };
};
export const setAllowTodragAndDropFromVALIDATION = allowTodragAndDropFromVALIDATION => {
  return {
    type: "SET_ALLOW_TO_DRAG_AND_DROP_FROM_VALIDATION",
    allowTodragAndDropFromVALIDATION
  };
};
export const setActivateNotifications = activateNotifications => {
  return {
    type: "SET_ACTIVATE_NOTIFICATIONS",
    activateNotifications
  };
};

export const setActivateCalendarNotifications = activateCalendarNotifications => {
  return {
    type: "SET_ACTIVATE_CALENDAR_NOTIFICATIONS",
    activateCalendarNotifications
  };
};

export const setActivateCarteNotifications = activateCarteNotifications => {
  return {
    type: "SET_ACTIVATE_CARTE_NOTIFICATIONS",
    activateCarteNotifications
  };
};

export const setAllowAccessClientSpace = allowAccessClientSpace => {
  return {
    type: "SET_ALLOW_ACCESS_CLIENT_SPACE",
    allowAccessClientSpace
  };
};

export const setAllowAccessToClientList = allowAccessToClientList => {
  return {
    type: "SET_ALLOW_ACCESS_CLIENT_LIST",
    allowAccessToClientList
  };
};

export const setAllowAccessToCollaboratorList = allowAccessToCollaboratorList => {
  return {
    type: "SET_ALLOW_ACCESS_COLLABORATOR_LIST",
    allowAccessToCollaboratorList
  };
};

export const setAllowCreateCorrectionCards = allowCreateCorrectionCards => {
  return {
    type: "SET_ALLOW_CREATE_CORRECTION_CARDS",
    allowCreateCorrectionCards
  };
};

/**
 * Reporting authorizations
 */

export const setAllowAccessReporting = allowAccessReporting => {
  return {
    type: "SET_ALLOW_ACCESS_REPORTING",
    allowAccessReporting
  };
};

export const setAllowAccessReportingTab = allowAccessReportingTab => {
  return {
    type: "SET_ALLOW_ACCESS_REPORTING_TAB",
    allowAccessReportingTab
  };
};

export const setAllowAccessProductionCapacity = allowAccessProdCapacity => {
  return {
    type: "SET_ALLOW_ACCESS_PRODUCTION_CAPACITY",
    allowAccessProdCapacity
  };
};

export const setAllowAccessBonusPlan = allowAccessBonusPlan => {
  return {
    type: "SET_ALLOW_ACCESS_BONUS_PLAN",
    allowAccessBonusPlan
  };
};

export const setAllowAccessEcheance = allowAccessEcheance => {
  return {
    type: "SET_ALLOW_ACCESS_ECHEANCE",
    allowAccessEcheance
  };
};

export const setAllowAccessBalanceRecap = allowAccessBalanceRecap => {
  return {
    type: "SET_ALLOW_ACCESS_BALANCE_RECAP",
    allowAccessBalanceRecap
  };
};

export const setAllowAccessCalendar = allowAccessCalendar => {
  return {
    type: "SET_ALLOW_ACCESS_CALENDAR",
    allowAccessCalendar
  };
};

export const setAllowAccessTimeReport = allowAccessTimeReport => {
  return {
    type: "SET_ALLOW_ACCESS_TIME_REPORT",
    allowAccessTimeReport
  };
};

export const setAllowAccessPortfolios = allowAccessPortfolio => {
  return {
    type: "SET_ALLOW_ACCESS_PORTFOLIOS",
    allowAccessPortfolio
  };
};

export const setAllowAccessErrorReporting = allowAccessErrReporting => {
  return {
    type: "SET_ALLOW_ACCESS_ERROR_REPORTING",
    allowAccessErrReporting
  };
};

export const setAllowAccessVacationMatrix = allowAccessVacationMatrix => {
  return {
    type: "SET_ALLOW_ACCESS_VACATION_MATRIX",
    allowAccessVacationMatrix
  };
};

export const setAllowAccessPlans = allowAccessPlan => {
  return {
    type: "SET_ALLOW_ACCESS_PLANS",
    allowAccessPlan
  };
};

export const setAllowAccessPrestations = allowAccessPrestation => {
  return {
    type: "SET_ALLOW_ACCESS_PRESTATIONS",
    allowAccessPrestation
  };
};

export const setAllowAccessPrestaTS = allowAccessPrestaTS => {
  return {
    type: "SET_ALLOW_ACCESS_PRESTA_TS",
    allowAccessPrestaTS
  };
};

export const setAllowAccessFinancial = allowAccessFinancial => {
  return {
    type: "SET_ALLOW_ACCESS_FINANCIAL",
    allowAccessFinancial
  };
};

export const setAllowAccessFinancialSheet = allowAccessFinancialSheet => {
  return {
    type: "SET_ALLOW_ACCESS_FINANCIAL_SHEET",
    allowAccessFinancialSheet
  };
};

export const setAllowAccessForfait = allowAccessForfait => {
  return {
    type: "SET_ALLOW_ACCESS_FORFAIT",
    allowAccessForfait
  };
};

export const setAllowAccessCroissance = allowAccessCroissance => {
  return {
    type: "SET_ALLOW_ACCESS_CROISSANCE",
    allowAccessCroissance
  };
};

export const setAllowAccessDynamicTable = allowAccessDynamicTab => {
  return {
    type: "SET_ALLOW_ACCESS_DYNAMIC_TABLE",
    allowAccessDynamicTab
  };
};

export const setAllowAccessCapacityPlanning = allowAccessCapPlan => {
  return {
    type: "SET_ALLOW_ACCESS_CAPACITY_PLANNING",
    allowAccessCapPlan
  };
};

export const setAllowAccessCapacityPlanningTab = allowAccessCapPlanTab => {
  return {
    type: "SET_ALLOW_ACCESS_CAPACITY_PLANNING_TAB",
    allowAccessCapPlanTab
  };
};

export const setAllowAccessSynthesis = allowAccessSynt => {
  return {
    type: "SET_ALLOW_ACCESS_SYNTHESIS",
    allowAccessSynt
  };
};

export const setAllowAccessSetting = allowAccessSetting => {
  return {
    type: "SET_ALLOW_ACCESS_SETTING",
    allowAccessSetting
  };
};

export const setAllowAccessCategorySetting = allowAccessCategorySetting => {
  return {
    type: "SET_ALLOW_ACCESS_CATEGORY_SETTING",
    allowAccessCategorySetting
  };
};

export const setAllowAccessTaskTypeSetting = allowAccessTaskTypeSetting => {
  return {
    type: "SET_ALLOW_ACCESS_TASK_TYPE_SETTING",
    allowAccessTaskTypeSetting
  };
};

export const setAllowAccessCollaboratorSetting = allowAccessCollaboratorSetting => {
  return {
    type: "SET_ALLOW_ACCESS_COLLABORATOR_SETTING",
    allowAccessCollaboratorSetting
  };
};

export const setAllowAccessCalendarSetting = allowAccessCalendarSetting => {
  return {
    type: "SET_ALLOW_ACCESS_CALENDAR_SETTING",
    allowAccessCalendarSetting
  };
};

export const setAllowCoefficientsConfig = allowCoefficientsConfig => {
  return {
    type: "SET_ALLOW_COEFFICIENTS_CONFIG_SETTING",
    allowCoefficientsConfig
  };
};

export const setAllowAccessModelSetting = allowAccessModelSetting => {
  return {
    type: "SET_ALLOW_ACCESS_MODEL_SETTING",
    allowAccessModelSetting
  };
};

export const setAllowAccessUserSetting = allowAccessUserSetting => {
  return {
    type: "SET_ALLOW_ACCESS_USER_SETTING",
    allowAccessUserSetting
  };
};

export const setAllowAccessSynchronization = allowAccessSynchronization => {
  return {
    type: "SET_ALLOW_ACCESS_SYNCHRONIZATION",
    allowAccessSynchronization
  };
};

export const setAllowAccessParameterSetting = allowAccessParameterSetting => {
  return {
    type: "SET_ALLOW_ACCESS_PARAMETER_SETTING",
    allowAccessParameterSetting
  };
};

export const setAllowAccess = (page, key, value) => ({
  type: "SET_ALLOW_ACCESS",
  payload: { page, key, value }
});

export const setAllowSubAccess = (page, subPage, key, value) => ({
  type: "SET_ALLOW_SUB_ACCESS",
  payload: { page, subPage, key, value }
});

export const resetAllowAccess = page => ({
  type: "RESET_ALLOW_ACCESS",
  page
});

export const resetAllowSubAccess = (page, subPage) => ({
  type: "RESET_ALLOW_SUB_ACCESS",
  payload: { page, subPage }
});

export const toggleViewDataBy = page => ({
  type: "TOGGLE_VIEW_DATA_BY",
  page
});

export const toggleViewSubDataBy = (page, subPage) => ({
  type: "TOGGLE_VIEW_SUB_DATA_BY",
  payload: { page, subPage }
});

export const toggleViewDataListBy = (page, subPage) => ({
  type: "TOGGLE_VIEW_SUB_DATA_LIST_BY",
  payload: { page, subPage }
});

export const setAllowViewDataBy = (page, option) => ({
  type: "SET_ALLOW_VIEW_DATA_BY",
  payload: { page, option }
});

export const setAllowViewSubDataBy = (page, subPage, option) => ({
  type: "SET_ALLOW_VIEW_SUB_DATA_BY",
  payload: { page, subPage, option }
});

export const setAllowViewSubDataListBy = (page, subPage, option) => ({
  type: "SET_ALLOW_VIEW_SUB_DATA_LIST_BY",
  payload: { page, subPage, option }
});



// WEBPACK FOOTER //
// ./src/actions/actions/authorizations-settings.js